// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2sdoU","clinicsSelect":"styles_clinicsSelect__3ghu_"};